import { AppConfig, CoreShopEnvironment } from '@App/Main.types';
import { Experiments } from '@Config/Experiments';
import { FeatureDefaults, Features } from '@Config/Features';
import { getBranchPreviewConfig } from '@Framework/branchPreview';
import { getExperimentsFromDev, getExperimentsWhichShouldGetInitiallyActivated } from '@Framework/experiments';
import { getFeaturesFromDev } from '@Framework/featureFlags';
import { trackAbTestEvent, trackDataLayerEvent } from '@Framework/tracking';
import ReactDOM from 'react-dom';

export function unmountOdsClient(containerElement: Element) {
  ReactDOM.unmountComponentAtNode(containerElement);
}

export function setInitConfig(config?: AppConfig) {
  let initConfig: AppConfig = {
    features: FeatureDefaults,
    experiments: getExperimentsWhichShouldGetInitiallyActivated(),
    triggerTrackingEvent: trackAbTestEvent,
    triggerDatalayerEvent: trackDataLayerEvent,
    language: process.env.REACT_APP_LANGUAGE ?? 'de',
    coreShopEnvironment: process.env.REACT_APP_CORE_SHOP_ENVIRONMENT ?? CoreShopEnvironment.Dev,
    tenant: process.env.REACT_APP_TENANT ?? 'com',
    referrerUrl:
      typeof document.referrer === 'string' && document.referrer.length > 0 ? document.referrer : location.href
  };

  if (process.env.REACT_APP_CORE_SHOP_ENVIRONMENT !== CoreShopEnvironment.Prod) {
    initConfig = {
      ...initConfig,
      ...getBranchPreviewConfig()
    };
  }

  if (config !== undefined) {
    initConfig = {
      ...initConfig,
      ...config
    };
  }

  const searchParams = new URLSearchParams(window.location.search.slice(1));
  searchParams && setFeatureOrExperimentViaUrlParams(searchParams, initConfig);

  const devPageExperiments = getExperimentsFromDev();
  devPageExperiments && setDevPageExperiments(devPageExperiments, initConfig);

  const devPageFeatures = getFeaturesFromDev();
  devPageFeatures && setDevPageFeatures(devPageFeatures, initConfig);

  return initConfig;
}

const setDevPageExperiments = (experiments, config) => {
  config.experiments = {
    ...config.experiments,
    ...experiments
  };
};

const setDevPageFeatures = (features, config) => {
  const initFeatureCopy = { ...config.features };

  if (config['features']) {
    delete config['features'];
    config.features = {
      ...initFeatureCopy,
      ...features
    };
  }
};

const setFeatureOrExperimentViaUrlParams = (searchParams, config) => {
  for (const param of searchParams) {
    if (param[0].indexOf('ft_') === 0) {
      const featureName: any = param[0].slice(3);
      const featureEnabled = parseInt(param[1]) === 1;
      if (Object.values(Features).includes(featureName)) {
        //console.log('set feature %s to %s', featureName, featureEnabled);
        config.features[featureName] = featureEnabled;
      } else {
        //console.log(`feature %s doesn't exist`, featureName);
      }
    }
    if (param[0].indexOf('exp_') === 0) {
      const experimentName: any = param[0].slice(4);
      const experimentEnabled = parseInt(param[1]) === 1;
      if (Object.values(Experiments).includes(experimentName)) {
        //console.log('set experiment %s to %s', experimentName, experimentEnabled);
        config.experiments[experimentName].active = true;
      } else {
        //console.log(`experiment %s doesn't exist`, experimentName);
      }
    }
  }
};
